import React from 'react';

import { useNavData } from './config-navigation';
import NavSectionVertical from './nav-vertical';

const MobileMenu = ({ open, onClose }) => {
  const navData = useNavData();

  return <NavSectionVertical openNav={open} onCloseNav={onClose} data={navData} />;
};

export default MobileMenu;
